// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__y+Qsb","size--small":"Modal_size--small__ljOTL","size--large":"Modal_size--large__EZE5z","open":"Modal_open__VZ0Gq"};